import React, { useEffect, useState } from "react";
import Scheduler, { SchedulerTypes } from "devextreme-react/scheduler";
import { collection, getDocs } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { db } from "../../lib/firebase";
import { EventData } from "../../interface/event.interface";
import "./style.css";

export default function CalendarPage() {
  const currentDate = new Date();

  const router = useNavigate();
  const [events, setEvents] = useState<SchedulerTypes.Appointment[]>([]);

  // Format date function to ensure proper formatting
  const formatDate = (date: Date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const eventsCollection = collection(db, "products"); // Adjust to your collection name
        const eventSnapshot = await getDocs(eventsCollection);

        const eventList = eventSnapshot.docs.map((doc) => {
          const data = doc.data() as EventData;
          const startDate = new Date(data.startdate);
          const endDate = new Date(data.enddate);

          return {
            id: doc.id,
            text: data.eventname,
            startDate: formatDate(startDate),
            endDate: formatDate(endDate),
          };
        });

        setEvents(eventList);
      } catch (error) {
        console.error("Error fetching events: ", error);
      }
    };

    fetchEvents();
  }, []);

  const views: SchedulerTypes.ViewType[] = ["month"];

  return (
    <>
      <Scheduler
        timeZone="America/Los_Angeles"
        dataSource={events}
        views={views}
        defaultCurrentView="month"
        defaultCurrentDate={currentDate}
        height={730}
        startDayHour={9}
        editing={{
          allowDragging: false,
          allowUpdating: false,
          allowAdding: false,
          allowDeleting: false,
          allowResizing: false,
        }}
        onAppointmentFormOpening={(e) => {
          e.cancel = true;
        }}
        onAppointmentClick={(e) => {
          const eventId = e.appointmentData.id;
          router(`/event-detail/${eventId}`);
        }}
      />
    </>
  );
}
